import React, { useState } from 'react';
import { Page } from '../../components';
import DhobaraPageLayout from '../../components/DhobaraPageLayout/DhobaraPageLayout';
import css from './ContactPage.module.css';

const TOPICS = [
  { value: '', label: 'Select a topic' },
  { value: 'buying', label: 'Buying a piece' },
  { value: 'selling', label: 'Selling / listing help' },
  { value: 'order', label: 'Order or shipping issue' },
  { value: 'returns', label: 'Returns & refunds' },
  { value: 'authenticity', label: 'Authenticity question' },
  { value: 'account', label: 'Account help' },
  { value: 'press', label: 'Press & partnerships' },
  { value: 'other', label: 'Something else' },
];

const ContactPage = () => {
  const [form, setForm] = useState({
    name: '',
    email: '',
    topic: '',
    orderNumber: '',
    subject: '',
    message: '',
  });
  const [errors, setErrors] = useState({});
  const [submitted, setSubmitted] = useState(false);

  const validate = () => {
    const e = {};
    if (!form.name.trim()) e.name = 'Please enter your name';
    if (!form.email.trim() || !/\S+@\S+\.\S+/.test(form.email)) e.email = 'Please enter a valid email address';
    if (!form.topic) e.topic = 'Please select a topic';
    if (!form.subject.trim()) e.subject = 'Please enter a subject';
    if (!form.message.trim() || form.message.trim().length < 20) e.message = 'Please enter a message (at least 20 characters)';
    return e;
  };

  const handleChange = e => {
    setForm(f => ({ ...f, [e.target.name]: e.target.value }));
    if (errors[e.target.name]) setErrors(er => ({ ...er, [e.target.name]: null }));
  };

  const handleSubmit = e => {
    e.preventDefault();
    const e2 = validate();
    if (Object.keys(e2).length) {
      setErrors(e2);
      return;
    }
    // In production this would call an API. For now we simulate success.
    setSubmitted(true);
  };

  const showOrderField = ['order', 'returns'].includes(form.topic);

  return (
    <Page
      title="Contact Us | Dhobara Support"
      description="Get in touch with the Dhobara team for help with buying, selling, orders, returns, or authenticity questions. We reply within 1–2 business days."
      scrollingDisabled={false}
    >
    <DhobaraPageLayout>
      <div className={css.pageHeader}>
        <span className={css.eyebrow}>Reach Out</span>
        <h1 className={css.pageTitle}>Get in <em>Touch</em></h1>
        <p className={css.pageSubtitle}>
          We're a small team that genuinely cares. Email us at{' '}
          <a href="mailto:admin@dhobara.com">admin@dhobara.com</a> or use the form below — we reply within 1–2 business days.
        </p>
      </div>

      <div className={css.content}>
        {submitted ? (
          <div className={css.successMsg}>
            Thank you for reaching out. We've received your message and will be in touch within 1–2 business days.
          </div>
        ) : (
          <form onSubmit={handleSubmit} noValidate>
            <div className={css.formGroup}>
              <label className={css.label} htmlFor="contact-name">Your Name</label>
              <input
                id="contact-name"
                name="name"
                type="text"
                className={css.input}
                value={form.name}
                onChange={handleChange}
                autoComplete="name"
              />
              {errors.name && <p className={css.error}>{errors.name}</p>}
            </div>

            <div className={css.formGroup}>
              <label className={css.label} htmlFor="contact-email">Email Address</label>
              <input
                id="contact-email"
                name="email"
                type="email"
                className={css.input}
                value={form.email}
                onChange={handleChange}
                autoComplete="email"
              />
              {errors.email && <p className={css.error}>{errors.email}</p>}
            </div>

            <div className={css.formGroup}>
              <label className={css.label} htmlFor="contact-topic">Topic</label>
              <select
                id="contact-topic"
                name="topic"
                className={css.select}
                value={form.topic}
                onChange={handleChange}
              >
                {TOPICS.map(t => (
                  <option key={t.value} value={t.value} disabled={t.value === ''}>{t.label}</option>
                ))}
              </select>
              {errors.topic && <p className={css.error}>{errors.topic}</p>}
            </div>

            {showOrderField && (
              <div className={css.formGroup}>
                <label className={css.label} htmlFor="contact-order">Order Number (optional)</label>
                <input
                  id="contact-order"
                  name="orderNumber"
                  type="text"
                  className={css.input}
                  value={form.orderNumber}
                  onChange={handleChange}
                  placeholder="e.g. DH-2025-00123"
                />
                <p className={css.orderNote}>If you have your order number, including it will help us respond faster.</p>
              </div>
            )}

            <div className={css.formGroup}>
              <label className={css.label} htmlFor="contact-subject">Subject</label>
              <input
                id="contact-subject"
                name="subject"
                type="text"
                className={css.input}
                value={form.subject}
                onChange={handleChange}
              />
              {errors.subject && <p className={css.error}>{errors.subject}</p>}
            </div>

            <div className={css.formGroup}>
              <label className={css.label} htmlFor="contact-message">Message</label>
              <textarea
                id="contact-message"
                name="message"
                className={css.textarea}
                value={form.message}
                onChange={handleChange}
                rows={6}
              />
              {errors.message && <p className={css.error}>{errors.message}</p>}
            </div>

            <button type="submit" className={css.submitBtn}>Send Message</button>
          </form>
        )}
      </div>
    </DhobaraPageLayout>
    </Page>
  );
};

export default ContactPage;
